import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  text: {
    textAlign: "center",
  },
  icon: {
    display: "block",
    margin: "0 auto",
  },
};
